var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamiliplusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 15.5,
    fill: "#EA0404"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2428 47.261C22.5435 47.261 15.4661 40.1833 15.4661 31.485C15.4661 22.7853 22.5435 15.708 31.2428 15.708C39.9418 15.708 47.0188 22.7853 47.0188 31.485C47.0188 40.1833 39.9418 47.261 31.2428 47.261ZM31.2428 11.2422C20.063 11.2422 11 20.3052 11 31.485C11 42.6644 20.063 51.7275 31.2428 51.7275C42.4226 51.7275 51.4856 42.6644 51.4856 31.485C51.4856 20.3052 42.4226 11.2422 31.2428 11.2422Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2429 15.708C22.5435 15.708 15.4662 22.7854 15.4662 31.4851C15.4662 40.1833 22.5435 47.261 31.2429 47.261C39.9418 47.261 47.0188 40.1833 47.0188 31.4851C47.0188 22.7854 39.9418 15.708 31.2429 15.708Z",
    fill: "#EA0404"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9832 37.2133H26.1128C24.364 37.2133 22.9411 35.7917 22.9411 34.0437C22.9411 32.2974 24.364 30.8762 26.1128 30.8762H30.6401V26.3411C30.6401 24.5944 32.063 23.1732 33.8118 23.1732C35.5606 23.1732 36.9832 24.5948 36.9832 26.3422V37.2133ZM33.8118 19.3877C29.9755 19.3877 26.8549 22.5069 26.8549 26.3411V27.091H26.1128C22.2766 27.091 19.1555 30.2099 19.1555 34.0437C19.1555 37.8785 22.2766 40.9981 26.1128 40.9981H38.8757C39.9196 40.9981 40.7684 40.1489 40.7684 39.1053V26.3411C40.7684 22.5069 37.6477 19.3877 33.8118 19.3877Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 15.5,
    stroke: "#DFE3E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamiliplusIcon);
export default __webpack_public_path__ + "static/media/FamiliplusIcon.899d10b4971645ac06d948fc5c06760a.svg";
export { ForwardRef as ReactComponent };